module.exports = __webpack_public_path__ + "static/media/br-se.3a5c42a5.svg";